import React from "react";
import { Box, Button, Typography } from "@material-ui/core";
import LockOutlinedIcon from "@material-ui/icons/LockOutlined";
import { withRouter } from "react-router-dom";

function Unauthorized({ history }) {
  return (
    <Box
      p={3}
      display="flex"
      flexDirection="column"
      alignItems="center"
      justifyContent="center"
      style={{ minHeight: "60vh", textAlign: "center" }}
    >
      <LockOutlinedIcon style={{ fontSize: 72, color: "#ef4444" }} />
      <Typography variant="h4" style={{ marginTop: 16, fontWeight: 600 }}>
        Access denied
      </Typography>
      <Typography variant="body1" style={{ marginTop: 8, color: "#6b7280", maxWidth: 460 }}>
        You don&apos;t have permission to view this page. If you believe this is
        a mistake, please contact your administrator.
      </Typography>
      <Box mt={3} display="flex" gridGap={12}>
        <Button variant="outlined" onClick={() => history.goBack()}>
          Go Back
        </Button>
        <Button
          variant="contained"
          color="primary"
          onClick={() => history.push("/app")}
        >
          Go to Home
        </Button>
      </Box>
    </Box>
  );
}

export default withRouter(Unauthorized);
